import { RetryStrategy } from './types';

const START_FROM = 0.5;
const MAX_ATTEMPT = 7;
const JITTER = 0.2;

export class ExponentialBackoffStrategy implements RetryStrategy {
    private attemptNumber = 0;

    nextAttempt(): Promise<void> {
        const waitUntilNextRetry =
            this.jitterUp(START_FROM * this.exponentBase2(Math.min(this.attemptNumber, MAX_ATTEMPT)), JITTER) * 1000;
        this.attemptNumber++;
        return new Promise<void>((resolve) => setTimeout(resolve, waitUntilNextRetry));
    }

    /**
     * exponentBase2 computes 2^(a-1) where a >= 1. If a is 0, the result is 0.
     */
    private exponentBase2(a: number): number {
        return (1 << a) >> 1;
    }
    /**
     * jitterUp adds random jitter to the duration.
     * This adds or subtracts time from the duration within a given jitter fraction.
     * For example for 10s and jitter 0.1, it will return a time within [9s, 11s])
     */
    private jitterUp(duration: number, jitter: number): number {
        const multiplier = jitter * (Math.random() * 2 - 1);
        return duration * (1 + multiplier);
    }
}
